import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  createTest: function (id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/quizzes", {
      course_id: id
    });
  },
  updatePassmark: function (id, pass_mark) {
    return axios.patch(IMPROVE_CONFIG.API_URL + "/quizzes/" + id, {
      pass_mark: pass_mark
    });
  },
  getQuestion: function (id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/question/" + id);
  },
  getTest: function (id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/quizzes/" + id);
  },
  getQuestions: function (id, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/quiz/questions/" + id + params);
  },
  deleteQuestion: function (id) {
    return axios.delete(IMPROVE_CONFIG.API_URL + "/question/" + id);
  },
  seedTests: function (id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/quiz/repopulate/" + id);
  },
  deleteQuestions: function (questions) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/questions", {
      questions: questions
    });
  },
  reseedTest: function (id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/quiz/reseed/"+id);
  },


  createQuestion: function (question, id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/question", {
      quiz_id: id,
      question: question.question,
      a: question.a,
      b: question.b,
      c: question.c,
      d: question.d,
      correct_answer: question.correct_answer,
      question_type:1,
      core_question:question.core
    });
  },
  updateQuestion: function (questionId, question, quizId) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/question/" + questionId, {
      quiz_id: quizId,
      question: question.question,
      a: question.a,
      b: question.b,
      c: question.c,
      d: question.d,
      correct_answer: question.correct_answer,
      question_type:1,
      core_question:question.core
    });
  },
  submitResults: function (quizId, answers, courseUserId, agree, signed_name) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/test/submit", {
      quiz_id: quizId,
      answers: answers,
      course_user_id: courseUserId,
      agree_statement: agree,
      signed_name : signed_name
    });
  },
  createFillQuestion: function (question, id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/fill-question", {
      quiz_id: id,
      question: question.question,
      a: question.a,
      correct_answer: question.correct_answer,
      question_type:2,
      core_question:question.core
    });
  },
  createMultiChoiceQuestion: function (question, id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/multi-question", {
      quiz_id: id,
      question: question.question,
      a: question.a,
      b: question.b,
      c: question.c,
      d: question.d,
      e: question.e,
      f: question.f,
      g: question.g,
      h: question.h,
      i: question.i,
      j: question.j,
      correct_answer: question.correct_answer,
      question_type:3,
      core_question:question.core
    });
  },
  createAssociationQuestion: function (question, id) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/association-question", {
      quiz_id: id,
      question: question.question,
      a: question.a,
      b: question.b,
      c: question.c,
      d: question.d,
      e: question.e,
      f: question.f,
      g: question.g,
      h: question.h,
      i: question.i,
      j: question.j,
      question_type:4,
      core_question:question.core
    });
  },
  updateFillQuestion: function (questionId, question, quizId) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/fill-question/" + questionId, {
      quiz_id: quizId,
      question: question.question,
      a: question.a,
      b: question.b,
      c: question.c,
      d: question.d,
      correct_answer: question.correct_answer,
      question_type:2,
      core_question:question.core
    });
  },
  updateMultiChoiceQuestion: function (questionId, question, quizId) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/multi-question/" + questionId, {
      quiz_id: quizId,
      question: question.question,
      a: question.a,
      b: question.b,
      c: question.c,
      d: question.d,
      e: question.e,
      f: question.f,
      g: question.g,
      h: question.h,
      i: question.i,
      j: question.j,
      correct_answer: question.correct_answer,
      question_type:3,
      core_question:question.core
    });
  },
  updateAssociationQuestion: function (questionId, question, quizId) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/association-question/" + questionId, {
      quiz_id: quizId,
      question: question.question,
      a: question.a,
      b: question.b,
      c: question.c,
      d: question.d,
      e: question.e,
      f: question.f,
      g: question.g,
      h: question.h,
      i: question.i,
      j: question.j,
      question_type:4,
      core_question:question.core
    });
  },
  updateAgreeStatement: function (id, statement, random, question_limit, pass_mark) {
    return axios.patch(IMPROVE_CONFIG.API_URL + "/quizzes-statement/" + id, {
      agree_statement: statement,
      random_question:random,
      question_limit:question_limit,
      pass_mark:pass_mark
    });
  },
  getCourseTestLog: function (id, params) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/quiz/logs/" + id + params);
  },
  getScore: function (quizId, answers, courseUserId) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/test/getscore", {
      quiz_id: quizId,
      answers: answers,
      course_user_id: courseUserId
    });
  },
  getQuizLog: function (id) {
    return axios.get(IMPROVE_CONFIG.API_URL + "/quiz/log/" + id);
  },
};
